module.exports = __webpack_public_path__ + "static/media/caracteristicas.b0ba07cc.jpg";